import React, { useEffect } from 'react';
import { generatePath, Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Breadcrumbs, Paper, Typography } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../routes';
import ModuleButtons from './ModuleButtons';
import { NEED_TO_KNOW_MODULE_NAME } from '../LearningCenterMobile/LearningCenterMobileView';
import { updateUserCourseModule } from '../../../actions/users';

const LearningCenterMobileNeedToKnowBreadcrumbs = () => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={Link}
        to={generatePath(routes.mobileDashboard)}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
      />
      <StyledRescuerTextBreadcrumb component={Link} to={generatePath(routes.mobileDashboardLearn)} label="Learn" />
      <StyledRescuerTextBreadcrumb component="a" href="#" label="Need To Know" />
    </Breadcrumbs>
  </Box>
);

const NeedToKnowModule = ({ userId, course, nextTab, setCurrentCoursesState, isMobile = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, needToKnow, modules = [] } = course;
  const module = modules.find((m) => m.name === NEED_TO_KNOW_MODULE_NAME);

  if (!id) {
    if (isMobile) {
      return history.push(generatePath(routes.mobileDashboardLearn));
    }
    return history.push(generatePath(routes.learn));
  }

  useEffect(() => {
    if (module.id && !module.completed) {
      dispatch(updateUserCourseModule(userId, id, module.id));
    }
    setCurrentCoursesState(id);
  }, [module]);

  return (
    <>
      {isMobile && <LearningCenterMobileNeedToKnowBreadcrumbs />}

      <Box
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          backgroundColor: 'background.default',
          flexDirection: 'column',
          padding: 1,
        }}
      >
        <Typography variant="h6">Need To Know</Typography>

        <Paper sx={{ padding: 1, marginTop: 1 }}>
          <Box component="ul" sx={{ padding: 2, margin: 0 }}>
            {(needToKnow || []).map((paragraph) => (
              <Box component="li" key={paragraph} sx={{ marginBottom: 1 }}>
                <Typography variant="body2">{paragraph}</Typography>
              </Box>
            ))}
          </Box>
        </Paper>

        <ModuleButtons nextTab={nextTab} courseId={id} isMobile={isMobile} />
      </Box>
    </>
  );
};

export default NeedToKnowModule;
